module.exports = __webpack_public_path__ + "img/garage.29a49ef5.svg";